import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import gruserReducers from '@wix/da-gruser-shared/pkg/redux/reducers';
import sharedConfigReducers from '@wix/da-redux-config/pkg/reducers';
import measuredCookieReducers from '@wix/da-hooks/pkg/useMeasureElement/redux/reducer';
import publicSessionReducers from '../../publicSession/reducers';
import watchButtonReducers from '../../WatchButton/redux/reducers';
import commentEditorReducersNew from '../../CommentEditor/redux/reducers';
import modalReducers from '../../Modals/redux/reducer';
import popoversReducers from '../../Popovers/redux/reducer';
import notificationReducers from '../../Notifications/redux/reducer';
import emoteSelectorReducers from '../../EmoteSelector/redux/reducers';
import writerReducers from '../../WriterPopup/redux/reducers';
import statusEditPopupReducers from '../../StatusEditPopup/reducers';
import pollEditPopupReducers from '../../PollEditPopup/redux/reducer';
import userAvatarReducers from '../../User/AvatarPopover/reducers';
import streamReducers from '../../Stream/reducers';
import { entitiesReducers } from '../entities';
import collectionPanelReducers from '../../CollectionPanel/redux/reducer';
import siteHeaderReducer from '../../SiteHeader/redux/reducer';
import flagsReducers from '@wix/da-react-context/pkg/flags/redux/reducer';
import firstTimeFlagsReducers from '../firstTimeFlags/reducers';
import duperbrowseReducers from '../../Duperbrowse/redux/reducer';
import deviationBackgroundReducer from '../../DeviationBackground/redux/reducer';
import moderationReducer from '../../Moderation/redux/reducer';
import deviationPageReducer from '../../DeviationPage/redux/reducer';
import addToGroupReducer from '../../AddToGroupsPanel/redux/reducer';
import artBrandedPopupReducer from '../../ArtBrandedPopup/redux/reducers';
import biReducer from '../../biLogger/redux/reducer';
import coreBadgeReducer from '../../coreBadge/redux/reducer';
import networkbarReducer from '../../NetworkBar/redux/reducer';
import simpleXHRReducer from '../../simpleXHR/reducer';
import uploadsReducers from '../uploads/reducers';
import tagInputReducer from '../../TagInput/redux/reducer';
import reportPageReducer from '../../ReportPage/redux/reducers';
import temporaryUnreadChatsReducer from '../../Notes/redux/unreadChats/reducer';
import birthdayPopupReducer from '../../BirthdayPopup/redux/reducers';
import pwaReducers from '../pwa/reducers';
import envReducer from '@wix/da-react-app/pkg/client/Environment/redux/reducers';
import commissionReducers from '../commissions/reducers';
export const reducers = _object_spread({}, envReducer, sharedConfigReducers, publicSessionReducers, watchButtonReducers, streamReducers, entitiesReducers, commentEditorReducersNew, modalReducers, popoversReducers, notificationReducers, emoteSelectorReducers, writerReducers, statusEditPopupReducers, pollEditPopupReducers, userAvatarReducers, collectionPanelReducers, flagsReducers, firstTimeFlagsReducers, siteHeaderReducer, measuredCookieReducers, duperbrowseReducers, deviationBackgroundReducer, moderationReducer, deviationPageReducer, addToGroupReducer, artBrandedPopupReducer, biReducer, coreBadgeReducer, networkbarReducer, simpleXHRReducer, uploadsReducers, tagInputReducer, reportPageReducer, temporaryUnreadChatsReducer, birthdayPopupReducer, gruserReducers, pwaReducers, commissionReducers);

//# sourceMappingURL=reducers.js.map